import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import IcalSyncManager from '../../../Components/Host/IcalSyncManager';
import { ArrowToLeft } from '../../../AssetComponents/Images';
import './CalendarSyncPage.css';

/**
 * CalendarSyncPage - Full page component for managing calendar synchronization
 * Matches the platform's UI design with proper back navigation
 */
const CalendarSyncPage = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    // Navigate back to previous page
    navigate(-1);
  };

  return (
    <div className="w-full h-[calc(100vh-120px)] overflow-auto flex flex-col">
      {/* Back Button */}
      <div
        onClick={handleBack}
        className="cursor-pointer space-y-[10px] mt-3 rounded-[16px] p-[16px] w-full lg:w-[1200px] mx-auto bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
      >
        <div className="flex items-center gap-[10px]">
          <ArrowToLeft />
          <div>Back</div>
        </div>
      </div>
      
      {/* Page Title */}
      <div className="w-full lg:w-[1200px] mx-auto mt-[20px]">
        <h1 className="page-title px-[16px]">Calendar Synchronization</h1>
      </div>

      {/* Main Content */}
      <div className="w-full flex flex-col items-center gap-[20px] justify-center my-[20px]">
        <div className="w-full lg:w-[1200px] h-max p-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
          <IcalSyncManager propertyId={propertyId} />
        </div>
      </div>
    </div>
  );
};

export default CalendarSyncPage;
